import { auth } from '../config/firebase';

export interface IntegrationAccount {
  id: string;
  platform: string;
  status: string;
  displayName?: string;
  connectedAt: string;
  isConnected: boolean;
  type: string;
  userId: string;
}

export interface Integration {
  id: string;
  name: string;
  logoUrl: string;
  authType: string;
  category: string[] | string | undefined;
  status: string;
  description?: string;
  website?: string;
  dashboardUrl?: string;
  documentPath?: string;
  slug?: string;
  priority?: number;
  createdAt?: string;
  updatedAt?: string;
  accounts?: IntegrationAccount[];
}

export interface IntegrationsResponse {
  success: boolean;
  data: {
    integrations: Integration[];
  };
  pagination?: {
    limit: number;
    offset: number;
    total: number;
  };
  meta?: {
    userId: string;
    timestamp: string;
    source: string;
    operation: string;
  };
}

export const getIntegrations = async (): Promise<IntegrationsResponse> => {
  const user = auth.currentUser;
  if (!user) {
    throw new Error('User not authenticated');
  }

  const token = await user.getIdToken();
  const response = await fetch('https://api.socialness.ai/management/integrations', {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch integrations: ${response.status}`);
  }

  return await response.json();
}; 